import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_45afe46d: FaireBrandEntity = {
  token: "b_45afe46d",
  type: "brand",
  name: "Anne Vaughan Designs Jewelry",
  avatarUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/a87dea9ccec056e2acc18efa61d43dc7dc7f6e3b760321dda28cc726426e9d07/1558129326.png",
  bannerUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/35543d681901bb87c3c5ea8081ca1db3bc66fa8e4d7875086552b17803e7282c/1558128833.png",
  logoUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/a87dea9ccec056e2acc18efa61d43dc7dc7f6e3b760321dda28cc726426e9d07/1558129326.png",
  heroImageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/35543d681901bb87c3c5ea8081ca1db3bc66fa8e4d7875086552b17803e7282c/1558128833.png",
  location: "Floyd, VA, USA",
  minimumOrderDollars: 0,
  rating: 4.9,
  reviewCount: 131,
  isTopShop: true,
  isInsider: true,
  description:
    "Founded in 2006, Anne Vaughan Designs was created so Anne could find a way to work while doing her first job - being a mom. Created in the basement of a tiny brick ranch home, Anne began creating one piece of jewelry a day as a side hustle after the birth of her son, Gabe. Soon her husband Aaron was creating displays and traveling with her to shows and teaching himself print and web marketing at night in order to help her. Tens of thousands of pieces of distinct jewelry later (all handcrafted in our studio) and dozens of retail locations across the United States, Anne continues to design each individual item with a talented team of makers supporting her work. Anne Vaughan Jewelry can be found at retail events, festivals and in unique boutiques and stores across the United States. Each design you see here is conceived and created from start to finish in our Floyd, Virginia studio with quality components.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:55:57.976Z",
    importedBy: "entity-db-cli",
  },
};
